import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-header',
  templateUrl: './mobile-header.component.html',
  styles: [
  ]
})
export class MobileHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
